export function resolvePlurals(
  n: number,
  firstForm: string,
  secondForm: string,
  thirdForm: string,
) {
  const pre = n + " ";
  if (n === 1) {
    return pre + firstForm;
  }

  if (
    n % 10 === 0 ||
    n % 10 === 1 ||
    n % 10 > 4 ||
    (n % 100 > 10 && n % 100 < 20)
  ) {
    return pre + secondForm;
  }

  return pre + thirdForm;
}

export function resolvePluralsChose(n: number) {
  return resolvePlurals(n, "wybrany", "wybranych", "wybrane");
}

export function resolvePluralsEpisodes(n: number) {
  return resolvePlurals(n, "odcinek", "odcinków", "odcinki");
}
